<div class="steps">
  <div id="hover-trigger" *ngFor="let stp of stepList" class="step line-step" [ngClass]="{'selected': step >= stp.index, 'no-selected': step < stp.index,
  'before-selected': step >= stp.index + 1, 'before-no-selected': step < stp.index + 1 && stp.index < stepList.length,
  'line-step': stp.index < stepList.length, 'line-step-1': stepList.length === 2 && stp.index < stepList.length,
  'line-step-2': stepList.length === 3 && stp.index < stepList.length, 'line-step-3': stepList.length === 4 && stp.index < stepList.length,
  'line-step-4': stepList.length === 5 && stp.index < stepList.length, 'line-step-5': stepList.length === 6 && stp.index < stepList.length }">
      <p class="font-sans text-l">{{ stp.index }}</p>
  </div>
</div>